import React, { useState, useEffect } from 'react';
import './NavAbout.css';
import Logo from '../../logo/doumicomlogo.png';
import bg1 from '../../images/Doumicomgroup.png';
import bg2 from '../../images/Doumicomgroup1.png';

const NavAbout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const backgroundImages = [bg1, bg2];
  const [bgIndex, setBgIndex] = useState(0);

  useEffect(() => {
    setCurrentPath(window.location.pathname);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    
    const bgTimer = setInterval(() => {
      setBgIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
    }, 5000);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(bgTimer); 
    };
  }, [backgroundImages.length]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (menuOpen) setDropdownOpen(false);
  };

  const isHomePage = currentPath === '/' || currentPath === '/home';

  return (
    <nav 
      className='navabout' 
      style={{ backgroundImage: `url(${backgroundImages[bgIndex]})` }}
    >
      <div className='navabout-logo'>
        <a href='/'><img src={Logo} alt='Doumicom-Logo-Main'/></a>
      </div>
      <div className='navabout-main-container'>
        {isMobile && (
          <button 
            className={`navabout-hamburger ${menuOpen ? 'active' : ''}`} 
            onClick={toggleMenu} 
            aria-label="Toggle navigation"
          >
            <span className="navabout-bar"></span>
            <span className="navabout-bar"></span>
            <span className="navabout-bar"></span>
          </button>
        )}
        <ul className={`navabout-links ${isMobile ? 'mobile-mode' : 'desktop-mode'} ${menuOpen ? 'show' : ''}`}>   
          {!isHomePage && (
            <li className="navabout-home-link">
              <a href='/'>
                <i className="fa fa-home" style={{ fontSize: 'clamp(18px, 2.5vw, 26px)' }}></i>
              </a>
            </li>
          )}
          <li><a href='/aboutus'>About Us</a></li>
          
          <li 
            className={`navabout-dropdown-item ${dropdownOpen ? 'active' : ''}`}
            onMouseEnter={() => !isMobile && setDropdownOpen(true)}
            onMouseLeave={() => !isMobile && setDropdownOpen(false)}
            onClick={() => isMobile && setDropdownOpen(!dropdownOpen)} 
          >
            <button className="dropdown-trigger-btn">
              Services <i className={`fa fa-caret-down arrow-icon ${dropdownOpen ? 'rotated' : ''}`}></i>
            </button>
            <ul className={`navabout-dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
              <li><a href='/services/sub1'>Submenu 1</a></li>
              <li><a href='/services/sub2'>Submenu 2</a></li>
              <li><a href='/services/sub3'>Submenu 3</a></li>
              <li><a href='/services/sub4'>Submenu 4</a></li>
              <li><a href='/services/sub5'>Submenu 5</a></li>
              <li><a href='/services/sub6'>Submenu 6</a></li>
              <li><a href='/services/sub7'>Submenu 7</a></li>
            </ul>
          </li>

          <li><a href='/partners'>Partners</a></li>
          <li><a href='/projects'>Projects</a></li>
          <li><a href='/clients'>Clients</a></li>
          <li><a href='/hse'>HSE</a></li>
          <li><a href='/contactus'>Contact</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default NavAbout;